import Backbone from 'backbone';
import { PageHeader, Icon } from '@evertrue/et-components';
import PropTypes from 'prop-types';

const EmailDetailHeader = ({ subject }) => {
  return (
    <PageHeader
      title={
        <div className="email-detail-header">
          <Icon
            icon="chevron-left"
            className="settings-back"
            onClick={() => {
              Backbone.history.history.back();
            }}
          />
          <h3>{subject}</h3>
        </div>
      }
    />
  );
};

EmailDetailHeader.propTypes = {
  subject: PropTypes.string.isRequired,
};

export default EmailDetailHeader;
